import React, { useRef } from 'react';

//Dependencies.
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { v4 } from 'uuid';
import { useParams } from 'react-router-dom';

//Functions - Firebase.
import { updateActiveChallengeInFS } from '../../../../../functions/firebase/firestore';

//Slice - actionCreators.
import { updateChallenge } from '../../../../../slices/challengesSlice';

//Slice - data
import { loggedInUser } from '../../../../../slices/allUsersSlice';
import { allActiveChallenges } from '../../../../../slices/challengesSlice';

import "./ActiveChallengeComments.styles.css";


const ActiveChallengeComments = () => {
   const currentlyLoggedInAs = useSelector(loggedInUser);
   const activeChallenges = useSelector(allActiveChallenges);

   const commentRef = useRef();
   const dispatch = useDispatch();
   const params = useParams();

   const _commentID = `comment-${v4()}`;
   const { _challengeID } = params;
   const { _userID, username, imageLink } = currentlyLoggedInAs;

   function handleSubmitComment(e) {
      e.preventDefault();
      
      const commentObject = {
         _commentID,
         _commentOwnerID: _userID,
         _commentOwnerUsername: username,
         imageLink,
         _challengeID,
         comment: commentRef.current.value
      }

      const type = 'allActiveChallenges';
      const key = _challengeID;

      const value = {
         ...activeChallenges[_challengeID],
         activeChallengeProperties: {
            ...activeChallenges[_challengeID].activeChallengeProperties, activeChallengeComments: [...activeChallenges[_challengeID].activeChallengeProperties.activeChallengeComments, { ...commentObject }]
         }
      };

      const updateCommentsPromise = new Promise((res, rej) => {
         const payload = { type, key, value };
         dispatch(updateChallenge({ ...payload }));

         res({ ...value });
         rej(`Oops... something went wrong trying to update comments to Firebase and/or Redux!!! The payload is ${JSON.stringify(payload)}.`);
      })

      updateCommentsPromise
         .then(successObject => {
            console.log({ message: "YEAH!!! Successfully updated comment in Redux and Firebase!!!", successObject, value });

            return updateActiveChallengeInFS(params._challengeID, { ...successObject })
         })
         .catch(error => {
            console.error({error, value});
         })

      e.target.reset();
   }

   return (
      <Form style={{
         padding: "1.5%",
         margin: "3%",
         borderRadius: "15px",
         border: "3px solid black",
         backgroundColor: "beige"
      }} onSubmit={ handleSubmitComment }>
         <fieldset>
            <legend>
               <strong className='text-danger'>ADD A COMMENT.</strong>
            </legend>
            <FormGroup>
               <Label htmlFor='user'>USER.</Label>
               <Input type='text' id='user' value={username} readOnly/>
            </FormGroup>
            <FormGroup>
               <Label htmlFor='comment'>ADD COMMENT.</Label>
               <Input type='textarea' placeholder='Add comment here.' style={{border: '3.5px solid black', backgroundColor: 'whitesmoke'}} innerRef={commentRef} />
            </FormGroup>
            <FormGroup>
               <Button color='danger' size='lg' type='submit'>SUBMIT YOUR COMMENT!!!</Button>
            </FormGroup>
         </fieldset>
      </Form>
   )
}

export default ActiveChallengeComments